var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "leasingVehicleCard" }, [
    _c(
      "a",
      { staticClass: "leasingVehicleCard__image", attrs: { href: _vm.url } },
      [
        _vm.image
          ? _c("img", {
              attrs: {
                src: _vm.image,
                alt: "" + _vm.title,
                title: "" + _vm.title,
                width: "232",
                height: "176",
              },
            })
          : _c("img", {
              attrs: {
                src: "/sites/petervardy/images/noImage320x240.jpg",
                alt: _vm.title + " - No Image",
              },
            }),
        _vm._v(" "),
        _vm.chips.length > 0
          ? _c(
              "div",
              { staticClass: "leasingVehicleCard__chips" },
              _vm._l(_vm.chips, function (chip, index) {
                return _c(
                  "div",
                  {
                    key: "chip-" + index,
                    staticClass: "leasingVehicleCard__chip",
                  },
                  [
                    _vm._v(
                      "\n                " + _vm._s(chip) + "\n            "
                    ),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "leasingVehicleCard__body" }, [
      _c("a", { attrs: { href: _vm.url } }, [
        _vm.title
          ? _c("h2", { staticClass: "leasingVehicleCard__title" }, [
              _vm._v(
                "\n                " + _vm._s(_vm.title) + "\n            "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.derivative
          ? _c("h3", { staticClass: "leasingVehicleCard__subtitle" }, [
              _vm._v(_vm._s(_vm.derivative)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.cheapestFinance && _vm.cheapestFinance.monthly_rental > 0
        ? _c("div", { staticClass: "leasingVehicleCard__price" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "leasingVehicleCard__price__value" }, [
              _vm._v(
                "\n                " +
                  _vm._s(
                    _vm._f("formatCurrency")(_vm.cheapestFinance.monthly_rental)
                  ) +
                  "\n            "
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ul", { staticClass: "leasingVehicleCard__contractList" }, [
        _c("li", { staticClass: "leasingVehicleCard__contractList__item" }, [
          _vm._v("Personal Contract Hire"),
        ]),
        _vm._v(" "),
        _vm.cheapestFinance && _vm.cheapestFinance.initial_payment
          ? _c(
              "li",
              { staticClass: "leasingVehicleCard__contractList__item" },
              [
                _vm._v(
                  "Initial Rental: " +
                    _vm._s(
                      _vm._f("formatCurrency")(
                        _vm.cheapestFinance.initial_payment
                      )
                    )
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cheapestFinance && _vm.cheapestFinance.term
          ? _c(
              "li",
              { staticClass: "leasingVehicleCard__contractList__item" },
              [_vm._v(_vm._s(_vm.cheapestFinance.term) + " Month Contract")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.cheapestFinance && _vm.cheapestFinance.mileage
          ? _c(
              "li",
              { staticClass: "leasingVehicleCard__contractList__item" },
              [
                _vm._v(
                  _vm._s(_vm._f("formatNumber")(_vm.cheapestFinance.mileage)) +
                    " Miles pa"
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "leasingVehicleCard__buttonGroup" }, [
        _c(
          "a",
          {
            staticClass:
              "redesignButton redesignButton--green redesignButton--full",
            attrs: { href: _vm.url },
          },
          [_vm._v("View Deal")]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "leasingVehicleCard__price__label" }, [
      _vm._v("\n                Monthly rental\n                "),
      _c("span", { staticClass: "leasingVehicleCard__price__vat" }, [
        _vm._v("(inc VAT)"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }